module.exports = __webpack_public_path__ + "media/images/countrysquared/mc-923518e0995f064a2e7574ad23e738c1.svg";